import get from 'lodash/get'

import MultipleBubble from '@/components/quiz/MultipleBubble.vue'
import Single from '@/components/quiz/Single.vue'
import SingleBubble from '@/components/quiz/SingleBubble.vue'
import SingleColor from '@/components/quiz/SingleColor.vue'
import * as compare from '@/services/compare'

const questionComponentMapping = {
  multipleBubble: MultipleBubble,
  single: Single,
  singleBubble: SingleBubble,
  color: SingleColor // TODO: put single color back when the contentful extension is changed
}

// this mapping define compare functions that are used to
// validate a response depending on the question type
// default: equals
const compareMapping = {
  multipleBubble: compare.sameItems
}

export const getQuizzes = state => state.quizzes

export const getQuizById = state => id => {
  return state.quizzes.find(el => el.id === id)
}

export const currentQuestion = (state, getters, rootState) => {
  if (rootState.route.name !== 'quizQuestion') {
    return null
  }

  const questionId = rootState.route.params.questionId
  return state.question.byId[questionId]
}

export const questionComponent = (state, getters) => {
  const currentQuestion = getters.currentQuestion

  if (!currentQuestion) {
    return null
  }

  return questionComponentMapping[currentQuestion.type]
}

// current quiz depending on the router path
export const currentQuiz = (state, getters, rootState) => {

  const { quizId, contentId } = rootState.route.params

  let quiz = state.currentQuiz || state.quizzes.find(el => el.id === quizId)

  if (contentId) {
    quiz = Object.assign({}, quiz, {
      questions: get(rootState, ['quiz', 'randomQuizQuestions', contentId], []),
      id: quizId
    })
  }

  return quiz
}

// computes the question progression in the quiz
// IOT return the current question number and the number of questions
export const questionProgression = (state, getters, rootState) => {
  if (rootState.route.name !== 'quizQuestion') {
    return null
  }

  const currentQuiz = getters.currentQuiz
  const numberOfQuestions = currentQuiz.questions.length

  const currentQuestionId = rootState.route.params.questionId
  const currentQuestion = currentQuiz.questions.findIndex(el => el.id === currentQuestionId) + 1

  return { currentQuestion, numberOfQuestions }
}

export const isLastQuizQuestion = (state, getters) => {
  const progression = getters.questionProgression

  if (!progression) return false

  return progression.currentQuestion === progression.numberOfQuestions
}

export const rightResponses = (state, getters) => {
  const currentQuiz = getters.currentQuiz

  if (!currentQuiz) {
    return []
  }

  return currentQuiz.questions.filter(question => {
    const questionType = state.question.byId[question.id].type
    const expectedResponse = state.question.byId[question.id].expectedResponse
    const userResponse = state.userResponses.byId[question.id]

    if (!userResponse) {
      return false
    }

    return isUserResponseRight(questionType, expectedResponse, userResponse)
  })
}

export const wrongResponses = (state, getters, rootState) => {
  const currentQuiz = getCurrentQuiz(state, getters, rootState)

  if (!currentQuiz) {
    return []
  }

  return currentQuiz.questions.filter(question => {
    const questionType = state.question.byId[question.id].type
    const expectedResponse = state.question.byId[question.id].expectedResponse
    const userResponse = state.userResponses.byId[question.id]

    if (!userResponse) {
      return false
    }

    return !isUserResponseRight(questionType, expectedResponse, userResponse)
  })
}

export const quizResult = (state, getters) => {
  const currentQuiz = getters.currentQuiz

  if (!currentQuiz) {
    return 0
  }

  return (getters.rightResponses.length / currentQuiz.questions.length) * 100
}

export const rightResponsesByQuiz = (state) => currentQuiz => {
  if (!currentQuiz) { 
    return []
  }
  return currentQuiz.questions.filter(question => {
    const questionType = state.question.byId[question.id].type
    const expectedResponse = state.question.byId[question.id].expectedResponse
    const userResponse = state.userResponses.byId[question.id]

    if (!userResponse) {
      return false
    }
    
    return isUserResponseRight(questionType, expectedResponse, userResponse)
  })
}

export const quizResultByQuiz = (state, getters, rootState) => quiz => {
  if (!quiz) {
    return 0
  }
  return (getters.rightResponsesByQuiz(quiz).length / quiz.numberOfQuestions) * 100
}

export const getComingFrom = state => {
  return state.comingFromProgression
}

export const quizFirebaseId = state => state.firebaseId


// FUNCTIONS TO HELP FOR GETTERS

/**
 * Get the current quiz (random or fallback to existing one)
 * @param {Object} state
 * @param {Object} getters
 * @param {Object} rootState
 * @returns {{ questions: string[] }}
 */
function getCurrentQuiz(state, getters, rootState) {
  const quizId = rootState.route.params.quizId

  if (state.randomQuizQuestions[quizId]) {
    return { questions: state.randomQuizQuestions[quizId] }
  }

  return getters.currentQuiz
}

function isUserResponseRight(questionType, expectedResponse, userResponse) {
  const compareFunction = compareMapping[questionType]

  if (compareFunction) {
    return compareFunction(expectedResponse, userResponse)
  }

  // default
  return expectedResponse.choice === userResponse.choice
}